var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hamburgerLine" }, [
    _c(
      "div",
      {
        staticClass: "arrow-bg",
        style: { backgroundImage: "url(" + _vm.switchBg + ")" },
        on: { click: _vm.toggleClick },
      },
      [
        _c("i", {
          staticClass: "arrow-icon",
          class: {
            "el-icon-arrow-left": _vm.isActive,
            "el-icon-arrow-right": !_vm.isActive,
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }